import { Spacer, Text } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const StackTrace = _ref => {
  let {
    error,
    errorInfo
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      type: Text.Type.Subtitle,
      theme: "inherit",
      width: Text.Width.Parent,
      children: error === null || error === void 0 ? void 0 : error.toString()
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs("details", {
      children: [/*#__PURE__*/_jsx("summary", {
        children: "Component Stack"
      }), /*#__PURE__*/_jsx(Text, {
        type: Text.Type.Caption,
        theme: "inherit",
        children: errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack
      })]
    })]
  });
};

export default StackTrace;